var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"projects-page d-flex flex-column justify-content-between"},[_c('div',[_c('Header'),_c('Banner'),_c('List')],1),_c('PageFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }